import React, { useState } from 'react'
import GenericFormHeaderComponent from '../forms/GenericFormHeaderComponent'
import Icons from '../../assets/icons'
import GenericCustomButton from '../GenericCustomButton';
import { FileText } from 'lucide-react';
import ParentModal from '../ParentModal';
import { getFileNameFromExt, getFileTypeFromUrl } from '../../helper/helperTableFunctions';
import GenericMediaViewModal from '../media/GenericMediaViewModal';
import TextWithTooltip from '../TextWithTooltip';

const ViewAllVendorDetails = (props) => {
    const {vendorCode, vendorName, selectedData} = props;

    const [selectedModal, setSelectedModal] = useState(null);
    const [selectedInnerData, setSelectedInnerData] = useState(null);

    const handleChange = (type, data) => {
        switch (type) {
            case "": {
				
				break;
			}
        
            default:
                setSelectedModal(type);
                setSelectedInnerData(data);
                break;
        }
    }

    const getParentChildProps = () => {
        let payload = {
            animationType: "bottom",
            // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', margin: 0, position: "fixed", borderRadius: 0 },
            parentModalOuterMostClassName: 'flex items-center justify-center',
            postitionProps: { position: 'relative' },
            dimensions: { width: "70%", height: "80%" },
            closeModal: () => {setSelectedModal(false); setSelectedInnerData(null);},
        }

        switch (selectedModal) {
            case "viewMedia": {
                let extName = getFileTypeFromUrl(selectedInnerData);
                let type = getFileNameFromExt(extName)
                return {
                    animationType: "bottom",
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "100vw", height: "100vh", backgroundColor: 'transparent' },
                    closeModal: () => setSelectedModal(false),
                    filesData: [
                        {
                            fileUrl: selectedInnerData || "",
                            fileType: type,
                        }
                    ]
                }
            }
        }
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "viewMedia": return GenericMediaViewModal;
        }
    }

  return (
    <>
        <div className='h-full w-full flex flex-col'>
            <GenericFormHeaderComponent
                label={{
                    contentPrimary: () => (
                        <div>
                            <h4 className='!mb-2'>Vendor Details</h4>
                            <div className='flex items-baseline gap-2'>
                                <div className='flex items-center gap-2'>
                                    <Icons.VendorStore className='shrink-0'/>
                                    <h4 className='mb-0'>{vendorName || ''}</h4>
                                </div>
                                <p className='relative bottom-[4px] !text-[11px] !text-fontBlack'>{vendorCode || ''}</p>
                            </div>
                        </div>
                    )
                }}
                closeModal={props.closeModal}
            />
            <div className='mt-[4px] p-[15px] pt-[0] h-full overflow-auto'>
                <div className='mb-5 grid grid-cols-5 gap-5 items-start'>
                    {
                        selectedData?.overview?.map((item, index) => (
                            <div key={index} className=''>
                                <p className='mb-0.5 text-[10px] text-[#6A6C70]'>{item?.label || ''}</p>
                                <TextWithTooltip
                                    as='p'
                                    width={170}
                                    text={item?.value || ''}
                                    className='mb-1.5 text-xs font-medium text-[#111D31]'
                                />
                                {/* <p className='mb-1.5 text-xs font-medium text-[#111D31] truncate'>{item?.value || '-'}</p> */}
                                {item?.attachment?.fileName && <div className='px-2 py-1 bg-[#F5F5F5] rounded-[3px] w-fit'>
                                    <GenericCustomButton
                                        type='underline2'
                                        label={item?.attachment?.fileName || 'View'}
                                        leftIcon={<FileText size={16} color='#AEAEB0' className='shrink-0' />}
                                        onClick={()=>handleChange('viewMedia', item?.attachment?.url || '')}
                                        className='max-w-[100px] truncate'
                                    />
                                </div>}
                            </div>
                        ))
                    }
                </div>
                <div className='mb-5'>
                    <h4 className='mb-1.5 uppercase text-[11px] font-semibold text-[#8496A9]'>Billing Details:</h4>
                    <div className='grid grid-cols-5 gap-5 items-start'>
                        {
                            selectedData?.billingDetails?.map((item, index) => (
                                <div key={index} className=''>
                                    <p className='mb-0.5 text-[10px] text-[#6A6C70]'>{item?.label || ''}</p>
                                    <TextWithTooltip
                                        as='p'
                                        width={170}
                                        text={item?.value || ''}
                                        className='mb-1.5 text-xs font-medium text-[#111D31]'
                                    />
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className='mb-5'>
                    <h4 className='mb-1.5 uppercase text-[11px] font-semibold text-[#8496A9]'>Shipping Details:</h4>
                    <div className='grid grid-cols-5 gap-5 items-start'>
                        {
                            selectedData?.shippingDetails?.map((item, index) => (
                                <div key={index} className=''>
                                    <p className='mb-0.5 text-[10px] text-[#6A6C70]'>{item?.label || ''}</p>
                                    <TextWithTooltip
                                        as='p'
                                        width={170}
                                        text={item?.value || ''}
                                        className='mb-1.5 text-xs font-medium text-[#111D31]'
                                    />
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div>
                    <h4 className='mb-1.5 uppercase text-[11px] font-semibold text-[#8496A9]'>Other Details:</h4>
                    <div className='grid grid-cols-5 gap-5 items-start'>
                        {
                            selectedData?.otherDetails?.map((item, index) => (
                                <div key={index} className=''>
                                    <p className='mb-0.5 text-[10px] text-[#6A6C70]'>{item?.label || ''}</p>
                                    <TextWithTooltip
                                        as='p'
                                        width={170}
                                        text={item?.value || ''}
                                        className='mb-1.5 text-xs font-medium text-[#111D31]'
                                    />
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
        {
            selectedModal && <ParentModal
                getParentChildProps={getParentChildProps()}
                childComponent={getChildComponent()}
                closeModal={() => { setSelectedModal(false) }}
            />
        }
    </>
  )
}

export default ViewAllVendorDetails
